export default "__VITE_ASSET__DFFCz7Xk__"